import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import './Referidos.css';

export default function Referidos() {
  const [nombreRefiere, setNombreRefiere] = useState('');
  const [telRefiere, setTelRefiere] = useState('');
  const [emailRefiere, setEmailRefiere] = useState('');
  const [nombreReferido, setNombreReferido] = useState('');
  const [telReferido, setTelReferido] = useState('');
  const [emailReferido, setEmailReferido] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const enviar = async () => {
    if (!nombreRefiere || !telRefiere || !emailRefiere || !nombreReferido || !telReferido) {
      toast.warn('Completa todos los campos obligatorios');
      return;
    }
    setEnviando(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const res = await fetch(`${apiUrl}/prod/referido`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombre_refiere: nombreRefiere,
          telefono_refiere: telRefiere,
          email_refiere: emailRefiere,
          nombre_referido: nombreReferido,
          telefono_referido: telReferido,
          email_referido: emailReferido,
        }),
      });
      const data = await res.json();
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
      if (body.ok) {
        setEnviado(true);
        toast.success('Referido enviado correctamente');
      } else {
        toast.error(body.error || 'Error al enviar');
      }
    } catch {
      toast.error('Error de conexión');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="ref-page">
      <div className="ref-hero">
        <span className="ref-badge">🎁 Programa de Referidos</span>
        <h1>Invita a un amigo y gana</h1>
        <p>Recomienda MonkeyPhone a tus amigos y familiares. Nosotros los contactamos.</p>
      </div>

      {enviado ? (
        <div className="ref-success">
          <h2>🎉 Referido enviado</h2>
          <p>Tu amigo recibirá un correo con sus datos de acceso como vendedor MonkeyPhone. ¡Gracias por recomendar!</p>
          <button className="ref-btn" style={{ marginTop: 16, maxWidth: 200 }} onClick={() => {
            setEnviado(false); setNombreReferido(''); setTelReferido(''); setEmailReferido('');
          }}>
            Referir a otro amigo
          </button>
        </div>
      ) : (
        <>
          <div className="ref-card">
            <h3>Tus datos</h3>
            <input className="ref-input" placeholder="Tu nombre *" value={nombreRefiere} onChange={(e) => setNombreRefiere(e.target.value)} />
            <input className="ref-input" type="tel" placeholder="Tu teléfono" value={telRefiere} onChange={(e) => setTelRefiere(e.target.value)} />
            <input className="ref-input" type="email" placeholder="Tu correo electrónico *" value={emailRefiere} onChange={(e) => setEmailRefiere(e.target.value)} />
          </div>

          <div className="ref-card">
            <h3>Datos de tu amigo</h3>
            <input className="ref-input" placeholder="Nombre de tu amigo *" value={nombreReferido} onChange={(e) => setNombreReferido(e.target.value)} />
            <input className="ref-input" type="tel" placeholder="Teléfono de tu amigo *" value={telReferido} onChange={(e) => setTelReferido(e.target.value)} />
            <input className="ref-input" type="email" placeholder="Email de tu amigo (opcional)" value={emailReferido} onChange={(e) => setEmailReferido(e.target.value)} />
            <button className="ref-btn" onClick={enviar} disabled={enviando}>
              {enviando ? '⏳ Enviando...' : '🎁 Enviar Referido'}
            </button>
          </div>
        </>
      )}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
